import React, { useContext, useEffect } from "react";
import { FilterContext } from "../FilterContext";
import { areArrayValuesEqual } from "../FilterGroups/instructionUtils";
import MultiPickerFilterPopup from "./MultiPickerFilterPopup";
import { getSortedClientNames, initialClientFilter } from "./FilterTypes/ClientFilterType";
import MultiClientList from "components/Picker/Client/MultiClientList";

const ClientFilter = () => {
  const title = RESX.Client.resxClient;

  const { register, getValue, setInitialValue, setValue } = useContext(FilterContext);
  register("client", {
    getTitle: () => title,
    renderSelection: (filter) => <>{getSortedClientNames(filter).join(", ")}</>,
    hasValue: (filter) => filter.clients.length > 0,
    reset: () => initialClientFilter,
    areEqual: (a, b) => areArrayValuesEqual(a.clients.map(c => c.clientId), b.clients.map(c => c.clientId))
  });
  useEffect(() => {
    setInitialValue("client", initialClientFilter);
  }, []);

  const [selectedClients, setSelectedClients] = React.useState<server.dto.ClientSmall[]>(initialClientFilter.clients);
  const [popupOpen, setPopupOpen] = React.useState<boolean>(false);

  const onPopupClose = () => {
    onApply();
  };

  const onPopupOpen = () => {
    setSelectedClients(getValue("client").clients);
    setPopupOpen(true);
  };

  const onApply = (e?) => {
    e?.preventDefault();
    setValue("client", { clients: selectedClients });
    setPopupOpen(false);
  };

  return <div>
    <MultiPickerFilterPopup
      title={title}
      minHeight={350}
      width={400}
      open={popupOpen}
      onClose={onPopupClose}
      onOpen={onPopupOpen}
      onApply={onApply}
    >
      <MultiClientList
        value={selectedClients}
        onChange={setSelectedClients}
      />
    </MultiPickerFilterPopup>
  </div>;
};

export default ClientFilter;
